import oppregState from './requestOppreg/state'
import oppregGetters from './requestOppreg/getters'
import oppregMutations from './requestOppreg/mutations'
import oppregActions from './requestOppreg/actions'

import awsState from './requestAws/state'
import awsMutations from './requestAws/mutations'

import requestManagedServicesState from './requestManagedServices/state'
import requestManagedServicesMutations from './requestManagedServices/mutations'
import requestManagedServicesActions from './requestManagedServices/actions'

import attestationState from './attestation/state'
import attestationMutations from './attestation/mutations'
import attestationActions from './attestation/actions'

export default {
  requestOppreg: {
    namespaced: true,
    state: oppregState,
    getters: oppregGetters,
    mutations: oppregMutations,
    actions: oppregActions
  },
  requestAws: {
    namespaced: true,
    state: awsState,
    getters: null,
    mutations: awsMutations,
    actions: null
  },
  requestManagedServices: {
    namespaced: true,
    state: requestManagedServicesState,
    getters: null,
    mutations: requestManagedServicesMutations,
    actions: requestManagedServicesActions
  },
  attestation: {
    namespaced: true,
    state: attestationState,
    getters: null,
    mutations: attestationMutations,
    actions: attestationActions
  }
}
